import {
    addInsertLinkViewState,
    onUploadDone,
    removeInsertLinkViewState,
} from '../actions/internalActions';
import getInsertLinkViewState from '../selectors/getInsertLinkViewState';
import InsertLinkViewState from '../store/schema/InsertLinkViewState';
import getStore from '../store/store';
import { InsertLinkFailureType } from '../types/InsertLinkFailureType';
import { onFluidFileCreationFailed, onFluidPlaceholderCreated } from 'owa-fluid-link';
import { onFluidLinkCreated } from 'owa-link-data';
import { mutator } from 'satcheljs';

mutator(addInsertLinkViewState, actionMessage => {
    const store = getStore();
    const InsertLinkViewState: InsertLinkViewState = {
        linkId: actionMessage.linkId,
        isRetrievingSharingLink: true,
        file: actionMessage.file,
        insertFailureType: InsertLinkFailureType.Unknown,
        upsellProperties: actionMessage.upsellProperties,
        displayText: actionMessage.displayText,
    };

    store.insertLinks.set(actionMessage.linkId, InsertLinkViewState);
});

mutator(onFluidPlaceholderCreated, actionMessage => {
    const store = getStore();
    const InsertLinkViewState: InsertLinkViewState = {
        linkId: actionMessage.containerId,
        isRetrievingSharingLink: true,
        file: undefined,
        insertFailureType: InsertLinkFailureType.Unknown,
        upsellProperties: undefined,
        displayText: '',
    };

    store.insertLinks.set(actionMessage.containerId, InsertLinkViewState);
});

mutator(removeInsertLinkViewState, actionMessage => {
    const store = getStore();
    store.insertLinks.delete(actionMessage.linkId);
});

mutator(onFluidLinkCreated, actionMessage => {
    const store = getStore();
    store.insertLinks.delete(actionMessage.containerId);
});

// VSO 88299 - decide if we want any kind of blocking dialog for fluid create failure
mutator(onFluidFileCreationFailed, actionMessage => {
    const store = getStore();
    store.insertLinks.delete(actionMessage.containerId);
});

mutator(onUploadDone, actionMessage => {
    const viewState = getInsertLinkViewState(actionMessage.linkId);
    if (viewState) {
        viewState.file = actionMessage.file;
        viewState.upsellProperties = null;
    }
});
